module.exports = __webpack_public_path__ + "img/cbc.38cd1641.png";